<div class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto p-2 lg:pl-0">
  <div class="p-4 bg-white dark:bg-zinc-950" [ngClass]="tutorialId ? '' : 'max-w-4xl rounded-lg border border-zinc-950/10 dark:border-white/10 shadow-lg' ">
    <form [formGroup]="tutorialForm" (ngSubmit)="onSave()">

      <section class="grid gap-4 sm:grid-cols-2">

        <!-- NAME -->
        <div class="space-y-1 sm:col-span-2">
          <label class="subheading">
            Name <span class="text-red-600">*</span>
          </label>

          <input formControlName="name" type="text" />

          <p *ngIf="submitted && form.name?.errors?.required"
             class="pt-1 text-red-600 text-xs">
            Name is required
          </p>
        </div>

        <!-- DESCRIPTION -->
        <div class="space-y-1 sm:col-span-2">
          <label class="subheading">
            Description <span class="text-red-600">*</span>
          </label>

          <textarea formControlName="description" rows="4"></textarea>

          <p *ngIf="submitted && form.description?.errors?.required"
             class="pt-1 text-red-600 text-xs">
            Description is required
          </p>
        </div>

        <div class="space-y-1">
          <label class="subheading">
            Type <span class="text-red-600">*</span>
          </label>

          <select formControlName="type">
            <option value="">Select Type</option>
            <option value="video">Video</option>
            <option value="document">Document</option>
            <option value="file">File</option>
          </select>
          <p *ngIf="submitted && form.type?.errors?.required"
            class="pt-1 text-red-600 text-xs">
            Type is required
          </p>
        </div>

        <!-- VIDEO URL -->
        <div *ngIf="tutorialForm.get('type')?.value !== 'file'" class="space-y-1 sm:col-span-1">
          <label class="subheading">
            URL <span class="text-red-600">*</span>
          </label>

          <input formControlName="videoURL" type="text"   [readonly]="tutorialForm.get('type')?.value === 'file'" />

          <p *ngIf="submitted && form.videoURL?.errors?.required"
             class="pt-1 text-red-600 text-xs">
            URL is required
          </p>
        </div>

        <div class="space-y-1" *ngIf="tutorialForm.get('type')?.value === 'document'">
          <label class="subheading">Thumbnail</label>

          <input type="text" formControlName="thumbnailURL" (input)="runValidator()" />

          <p *ngIf="submitted && form.thumbnailURL?.errors?.invalidImageUrl"
            class="pt-1 text-red-600 text-xs">
            Only .jpg, .jpeg or .png image URLs are allowed
          </p>
        </div>
  
         <div *ngIf="tutorialForm.get('type')?.value === 'file'">
                <div class="flex items-center gap-1.5">
                  <label for="role-type" class="block text-sm font-medium text-main-secondary">File<span
                      class="text-red-600">*</span></label>
                  <div class="relative inline-flex items-center" (outsideClick)="showFileInfo = false" outside-click>
                    <button type="button" (click)="toggleFileInfo($event)"
                      class="text-zinc-400 hover:text-zinc-600 dark:hover:text-zinc-200 transition-colors cursor-pointer flex items-center focus:outline-none"
                      aria-label="Supported file formats" title="Supported file formats">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                      </svg>
                    </button>
                    <div *ngIf="showFileInfo"
                      class="absolute left-0 top-full z-50 mt-1 w-72 sm:w-80 rounded-lg bg-white dark:bg-zinc-900 p-2.5 shadow-lg border border-zinc-200 dark:border-zinc-700 text-xs text-zinc-700 dark:text-zinc-300">
                      <div class="font-medium text-zinc-900 dark:text-zinc-100 mb-1 flex items-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3.5 h-3.5 text-primary">
                          <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                        </svg>
                        <span>Supported File Types</span>
                      </div>
                      <p class="text-zinc-600 dark:text-zinc-400 leading-normal">
                        .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .png, .jpg, .jpeg, .txt, .csv
                      </p>
                    </div>
                  </div>
                </div>
                <div class="mt-1">
              
                  <div class="flex justify-center rounded-md border-2 border-dashed border-gray-300 px-6 pt-5 pb-6">
                    <div class="space-y-1 text-center">
                      <svg *ngIf="!selectedFile && !tutorialForm.get('videoURL')?.value" class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none"
                        viewBox="0 0 48 48" aria-hidden="true">
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <div class="flex text-sm text-gray-600">
                        <label for="customFile"
                          class="relative cursor-pointer rounded-md bg-white font-medium text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:text-indigo-500">
                          <span *ngIf="!selectedFile && !tutorialForm.get('videoURL')?.value">Upload a file</span>
                          <span *ngIf="selectedFile !== null">{{selectedFile.name}}</span>
                          <span *ngIf="selectedFile === null && tutorialForm.get('videoURL')?.value">{{ getFileName(tutorialForm.get('videoURL')?.value) }}</span>
                          <input type="file" #fileInput (change)="onFileSelection($event)" id="customFile" name="file-upload"
                            class="sr-only"
                           />
                        </label>
                        <div>
                          <button *ngIf="selectedFile || tutorialForm.get('videoURL')?.value" type="button" (click)="deleteFile(fileInput)"
                            class="p-1 btn btn-danger rounded-full -top-2.5 -right-2.5 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                              stroke="currentColor" class="size-4">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="isUploading" class="mt-2 text-xs text-blue-600 font-medium flex items-center gap-1">
                  <svg class="animate-spin h-3.5 w-3.5 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                  </svg>
                  Uploading file, please wait...
                </div>
                <div *ngIf="tutorialForm.get('videoURL')?.value" class="mt-2 text-xs text-gray-500 break-all">
                  <a [href]="tutorialForm.get('videoURL')?.value" target="_blank" rel="noopener noreferrer"
                    class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">
                    {{ tutorialForm.get('videoURL')?.value }}
                  </a>
                </div>
                <div class="mt-2 text-red-600 text-xs" *ngIf="submitted && tutorialForm.get('type')?.value === 'file' && form.videoURL?.errors?.required">
                  <p class="pt-1 text-red-600 text-xs">
                    File is required
                  </p>
                </div>
                <div class="mt-2 text-red-600 text-xs" *ngIf="invalidFileType && submitted">
                  <p class="pt-1 text-red-600 text-xs">
                    Invalid file format
                  </p>
                </div>
                
          </div>
  
          <div class="space-y-1">
            <label class="subheading">Audience
              <span class="text-red-600">*</span>
            </label>
            <div>
              <!-- Using items input with multiple selection -->
              <ng-select [ngModelOptions]="{standalone: true}" [items]="types" bindLabel="label" bindValue="value"
                [(ngModel)]="selecteType" [multiple]="true" [clearable]="false" [closeOnSelect]="false" placeholder="Select Audience"
                [searchable]="true">
              </ng-select>
          
              <!-- Validation Message -->
              <div *ngIf="submitted && selecteType?.length === 0">
                <p *ngIf="form.audience?.errors?.required" class="pt-1 text-red-600 text-xs">
                  Audience is required
                </p>
              </div>
            </div>
          </div>

        <!-- ACTIVE -->
        <div class="space-y-1">
          <label class="subheading">Status</label>

          <select formControlName="isActive">
            <option [value]="true">Active</option>
            <option [value]="false">Inactive</option>
          </select>
        </div>

      </section>

      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

      <section class="flex justify-end gap-4">
        <button type="submit" [disabled]="isUploading" class="btn btn-secondary">
          {{ tutorialId ? 'Update' : 'Create' }}
        </button>
      </section>

    </form>
  </div>
</div>